import React from 'react';
import { useState, useEffect } from 'react';
import barChart from '../../../../assets/icons/bar-chart-square-02.png';
import arrow from '../../../../assets/icons/arrow-up.png';
import search_icon from '../../../../assets/icons/search_icon.png';
import plus from '../../../../assets/icons/plus.png';
import { Divider, Table } from 'antd';
import './style.css';
import { Navigate, useNavigate } from 'react-router-dom';
import {
  Card,
  Form,
  Input,
  Button,
  Row,
  Col,
  Steps,
  Upload,
  message,
  Select,
  Space,
  Tooltip,
  Modal,
  Spin,
} from 'antd';
import DashboardTable from '../dashboardTable/index.js';
import editReject from '../../../../assets/icons/edit_reject.png';
import check from '../../../../assets/icons/check.png';
import edit_icon from '../../../../assets/icons/edit_icon.png';
import view_icon from '../../../../assets/icons/view_icon.png';
import download_icon from '../../../../assets/icons/download_icon.png';
import tooltip_download from '../../../../assets/icons/tooltip_download.png';
import modal_download from '../../../../assets/icons/Modal_download.png';
import three_dots from '../../../../assets/icons/three_dots_1.png';
import arrow_down from '../../../../assets/icons/arrow_down.png';
import {
  getProjectList,
  getBbsList,
  getProjectCount,
  getApproverDashboard,
  getViewProject,
  setProjectData,
  getManagerDashboard,
  createManagerApproveProject,
  createManagerApproveUser,
  createNewBBS,
  setnewBBSData,
  getApproveReject,
  fetchOptimizatonCountDashboard,
  fetchProjectCountDashboard,
  getManagerProjectCount,
  getManagerOptimizationCount,
} from '../../redux/slice.js';
import { useSelector, useDispatch } from 'react-redux';
import CreateBBSPage from '../createBbs';
import moment from 'moment';
import LocalStorage from '../../../../utilities/localStorage.js';
import DashboardTableManager from '../DashboardTableManager';
import { useParams } from 'react-router-dom';
import ViewBBS from '../viewBBS';
import filterIcon from '@assets/icons/filter_icon.png';
import { generateYearsWithMonths } from '@utils/helpers';
import FilterDrawerMonthlyWithYear from './FilterDrawerMonthlyWithYear';
import { useMemo } from 'react';

const FINANCIAL_YEARS = generateYearsWithMonths(5);
// finding last quarter
const LAST_MONTH = `Select Month`;

const { Step } = Steps;

const DashboardPage = () => {
  const [isExistingBBS, setIsExistingBBS] = useState(false);
  //const [search, setSearch] = useState("");
  const { id } = useParams();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [isStepperFormVisible, setIsStepperFormVisible] = useState(false);
  const [open, setOpen] = useState(false);
  const [search, setSearch] = useState('');
  const [requesterSearch, setRequesterSearch] = useState('');
  const [managerSearch, setManagerSearch] = useState('');
  //const [search, setSearch] = useState('');
  const [form] = Form.useForm();
  const user_details = LocalStorage.getItem('bbs_user');
  console.log('user details: ', user_details);
  const [filterDataState, setFilterDataState] = useState([]);

  // const { allProjectList, locations, bbsList, projectCount } = useSelector(
  //   (state) => state.projectList,
  // );
  const {
    managerOptimizationCountDashboard,
    managerProjectCountDashboard,
    loading,
    approverDashboard,
    managerDashboard,
    newBBSData,
    viewProject,
    fetchApproveReject,
    projectCount,
    projectCountDashboard,
    optimizationCountDashboard,
  } = useSelector((state) => state.projectList);

  const [selectedFilters, setSelectedFilters] = useState([]);

  const [openDr, setDrOpen] = useState(false);
  const showDrawer = () => {
    setDrOpen(true);
  };

  const onClose = () => {
    setDrOpen(false);
  };

  const handleFilter = (filterData) => {
    setFilterDataState(filterData);
    const payload = {
      month_array: JSON.stringify(filterData.map((month) => month.complete)),
    };

    const selectedData = filterData.map(
      (data) => `${data.title}-${data.complete.slice(3)}`,
    );

    setSelectedFilters(selectedData);

    if (user_details?.user?.id) {
      const payload = {
        userId: user_details?.user?.id, // Use the actual user ID here
        page: currpage, // Current page for pagination
        month_array: JSON.stringify(filterData.map((month) => month.complete)),
      };
      dispatch(getApproverDashboard(payload));
      dispatch(
        fetchProjectCountDashboard({
          userId: user_details?.user?.id, // Use the actual user ID here
          month_array: JSON.stringify(
            filterData.map((month) => month.complete),
          ),
        }),
      );
      dispatch(
        fetchOptimizatonCountDashboard({
          userId: user_details?.user?.id,
          month_array: JSON.stringify(
            filterData.map((month) => month.complete),
          ),
        }),
      );
    }
    onClose();
  };

  const memoizedMonthFilter = useMemo(() => {
  return filterDataState.map((month) => month.complete);
}, [filterDataState]);

  useEffect(() => {
    dispatch(getViewProject({}));
  }, [dispatch]);

  useEffect(() => {
    dispatch(getProjectCount());
  }, [dispatch]);

  useEffect(() => {
    if (user_details?.user?.id) {
      dispatch(getManagerProjectCount({ manager_id: user_details.user.id }));
    }
  }, [dispatch, user_details?.user?.id]);
  
  useEffect(() => {
    if (user_details?.user?.id) {
      dispatch(getManagerOptimizationCount({ manager_id: user_details.user.id }));
    }
  }, [dispatch, user_details?.user?.id]);

  // console.log('managercount1: ',managerProjectCountDashboard)
  // console.log('managercount2: ',managerOptimizationCountDashboard)

  console.log('projectCount: ', projectCount);
  useEffect(() => {
    const paramsId = 'your_id_here'; // Replace with dynamic logic for the id
    dispatch(getApproveReject({ id: paramsId, payload: {} }));
  }, [dispatch]);

  useEffect(() => {
    // Only dispatch the action if the userId is present and has not been dispatched yet
    if (user_details?.user?.id) {
      dispatch(
        fetchProjectCountDashboard({
          userId: user_details?.user?.id,
        }),
      );
    }
  }, [user_details?.user?.id]);

  useEffect(() => {
    // Only dispatch the action if the userId is present and has not been dispatched yet
    if (user_details?.user?.id) {
      dispatch(
        fetchOptimizatonCountDashboard({
          userId: user_details?.user?.id,
        }),
      );
    }
  }, [user_details?.user?.id]);

  //console.log('viewProject: ',viewProject)
  // console.log('projectdountdash: ',projectCountDashboard)
  // console.log('projectdountdash11: ',optimizationCountDashboard)
  // console.log('approverejectfineal: ',fetchApproveReject)

  const dataSource =
    approverDashboard?.map((item) => {
      const {
        RequestApproval,
        user_status,
        request_approval_id,
        manager_user_remarks,
      } = item || {};
      const {
        BBs,
        project_name,
        project_code,
        project_status,
        quantity,
        id,
        sbg,
        sbu,
        bu,
        user_remarks,
        manager_project_remarks,
      } = RequestApproval || {};
      // console.log('testing: ',RequestApproval.id)

      return {
        key: project_code || Math.random(), // Unique key for each row
        project_name: project_name || 'N/A',
        project_code: project_code || 'N/A',
        sbg: sbg || 'N/A',
        sbu: sbu || 'N/A',
        bu: bu || 'N/A',
        request_approval_id: request_approval_id || 'N/A',
        project_status: project_status || 'N/A',
        quantity: quantity || 0,
        BBs: BBs || [], // Include BBS data for nested rendering if needed
        user_status: user_status || 'N/A',
      };
    }) || [];

  const managerDatasource =
    managerDashboard?.map((item) => {
      const {
        RequestApproval = {},
        user_status,
        User = {},
        request_approval_id,
      } = item || {};
      const {
        BBs,
        project_name,
        project_code,
        project_status,
        quantity,
        id,
        sbg,
        sbu,
        bu,
        user_remarks,
        manager_project_remarks,
      } = RequestApproval || {};
      const { givenName } = User || {};

      //console.log('managerdashboarddata 1; ',managerDashboard?.data?.RequestApproval?.project_name)
      console.log('RequestApproval_ID:', request_approval_id);

      return {
        key: project_code || Math.random(), // Unique key for each row
        project_name: project_name || 'N/A',
        project_code: project_code || 'N/A',
        sbg: sbg || 'N/A',
        sbu: sbu || 'N/A',
        bu: bu || 'N/A',
        request_approval_id: request_approval_id || 'N/A',
        givenName: givenName || 'N/A',
        project_status: project_status || 'N/A',
        quantity: quantity || 0,
        BBs: BBs || [], // Include BBS data for nested rendering if needed
        user_status: user_status || 'N/A',
      };
    }) || [];
  const handleCreateBBSId = () => {
    setIsStepperFormVisible(true);
  };

  const handleReturnToDashboard = () => {
    setIsStepperFormVisible(false); // Hide the stepper form and return to dashboard
    // dispatch(getBbsList());
    // dispatch(getProjectList());
    // dispatch(getProjectCount());
  };

  const handleProjectClick = (projectCode) => {
    // Log the received projectCode for debugging
    console.log('Clicked Project Code:', projectCode);

    if (!projectCode) {
      message.error('Invalid project code');
      return;
    }

    form
      .validateFields()
      .then(() => {
        dispatch(getViewProject({ projectCode }))
          .then((response) => {
            console.log('response.id: ', response.payload);
            if (response?.payload) {
              //message.success('Project view successfully created!');

              //dispatch(setProjectData(response.payload));
              console.log('viewProject inside function: ', viewProject);

              // Navigate to the project page
              navigate(`/request-approval/${projectCode}`);
            } else {
              message.error(response?.payload?.message || 'Unknown error');
            }
          })
          .catch((error) => {
            console.error('API call failed:', error);
            message.error('Failed to submit the form.');
          });
      })
      .catch((info) => {
        console.log('Validation failed:', info);
      });
  };

  const Id = user_details?.user?.id;

  const handleNewBBS = (Id) => {
    if (!Id) {
      console.error('User ID is not defined');
      return;
    }

    form
      .validateFields()
      .then((values) => {
        const payload = { userId: Id, page: currpage }; // Payload to pass to the API
        console.log('Payload:', payload);

        dispatch(createNewBBS(payload)) // Dispatch the API call
          .then((response) => {
            if (response?.payload?.success) {
              //message.success('Project view successfully created!');

              // Dispatch the data to Redux before navigating
              //dispatch(setProjectData(response.payload));

              // Navigate to the project page
              //dispatch(setnewBBSData(response.payload));
        
              navigate(`/dashboard/${Id}`);
            } else {

              navigate(`/dashboard/${Id}`); // Redirect even with empty response
            }
          })
          .catch((error) => {
            console.error('API call failed:', error);
            message.error('Failed to submit the form.');
          });
      })
      .catch((info) => {
        console.log('Validation failed:', info);
      });
  };

  const handleRequestClick = (RequestId) => {
    console.log('requestId:', RequestId);
    console.log('function id: ', id); // This will log the `id` from the URL
    // if (!id) {
    //   console.error('Invalid ID');
    //   return;
    // }
    let payload = {
      id: RequestId,
    };
    console.log('payloa_id: ', id);
    // Dispatch the API call with the ID
    dispatch(getApproveReject(payload))
      .then(() => {
        // After successful API call, navigate to the next page
        navigate(`/approve-reject/${RequestId}`);
      })
      .catch((error) => {
        console.error('Error during API call:', error);
      });
  };

  const handleModalClose = () => {
    setOpen(false); // Close the modal
  };

  // useEffect(() => {
  //   dispatch(getBbsList());
  // }, [dispatch]);

  // useEffect(() => {
  //   dispatch(getProjectCount());
  // }, [dispatch]);
  const [currpage, setCurrPage] = useState(1);
  useEffect(() => {
    if (user_details?.user?.id) {
      const payload = {
        userId: user_details?.user?.id, 
        page: currpage, 
      };
      dispatch(getApproverDashboard(payload));
    }
  }, [dispatch, user_details?.user?.id, currpage]);

    // useEffect(() => {
    //     if (user_details?.user?.id) {
    //       const payload = {
    //        // userId: user_details?.user?.id, 
    //         page: currpage ,
    //         search, 
    //         manager_id:user_details?.user?.id
    //       };
    //       dispatch(getManagerDashboard(payload));
    //     }
    //   }, [dispatch, user_details?.user?.id, currpage, search]); 
    

  useEffect(() => {
    dispatch(getManagerDashboard());
  }, [dispatch]);

  console.log('approver dashboard: ', approverDashboard);
  console.log('manager dashboard: ', managerDashboard);

  const handleViewClick = (record) => {
    console.log('View icon clicked for record:', record);
  };

  const handleDownloadClick = (record) => {
    console.log('View icon clicked for record:', record);
  };

  const handleFetchBBS = (id) => {
    let payload = {
      id: id,
    };
    console.log('payloa_id: ', id);
    dispatch(getApproveReject(payload))
      .then(() => {
        navigate(`/view-BBS/${id}`);
        //setIsExistingBBS(true)
      })
      .catch((error) => {
        console.error('Error during API call:', error);
      });
  };

  const handleUserApproveReject = (id) => {
    console.log('function id: ', id); // This will log the `id` from the URL
    // if (!id) {
    //   console.error('Invalid ID');
    //   return;
    // }
    let payload = {
      id: id,
    };
    console.log('payloa_id: ', id);
    // Dispatch the API call with the ID
    dispatch(getApproveReject(payload))
      .then(() => {
        // After successful API call, navigate to the next page
        navigate(`/user-approvereject/${id}`);
      })
      .catch((error) => {
        console.error('Error during API call:', error);
      });
  };

  const handleProjectApproveReject = (id) => {
    console.log('function id: ', id); // This will log the `id` from the URL
    // if (!id) {
    //   console.error('Invalid ID');
    //   return;
    // }
    let payload = {
      id: id,
    };
    console.log('payloa_id: ', id);
    // Dispatch the API call with the ID
    dispatch(getApproveReject(payload))
      .then(() => {
        // After successful API call, navigate to the next page
        navigate(`/user-approvereject/${id}`);
      })
      .catch((error) => {
        console.error('Error during API call:', error);
      });
  };


  const columns = [
    {
      title: (
        <span
          style={{
            marginLeft: '7px',
            color: '#667085',
            fontFamily: "'SF Pro Text', sans-serif",
            fontWeight: '500',
            fontSize: '12px',
          }}
        >
          SBG
        </span>
      ),
      dataIndex: 'sbg',
      key: 'sbg',
      width: '160px',
      ellipsis: true,
      render: (text, record) => (
        <span
          style={{
            marginLeft: '7px',
            color: '#667085',
            fontFamily: "'SF Pro Text', sans-serif",
            fontWeight: '500',
            fontSize: '12px',
          }}
        >
          {record?.RequestApproval?.sbg || 'N/A'}
        </span>
      ),
    },
    {
      title: (
        <span
          style={{
            color: '#667085',
            fontFamily: "'SF Pro Text', sans-serif",
            fontWeight: '500',
            fontSize: '12px',
          }}
        >
          SBU
        </span>
      ),
      dataIndex: 'sbu',
      key: 'sbu',
      width: '160px',
      ellipsis: true,
      render: (text, record) => (
        <span
          style={{
            color: '#667085',
            fontFamily: "'SF Pro Text', sans-serif",
            fontWeight: '500',
            fontSize: '12px',
          }}
        >
          {record?.RequestApproval?.sbu || 'N/A'}
        </span>
      ),
    },
    {
      title: (
        <span
          style={{
            color: '#667085',
            fontFamily: "'SF Pro Text', sans-serif",
            fontWeight: '500',
            fontSize: '12px',
          }}
        >
          BU
        </span>
      ),
      dataIndex: 'bu',
      key: 'bu',
      width: '160px',
      ellipsis: true,
      render: (text, record) => (
        <span
          style={{
            color: '#667085',
            fontFamily: "'SF Pro Text', sans-serif",
            fontWeight: '500',
            fontSize: '12px',
          }}
        >
          {record?.RequestApproval?.bu || 'N/A'}
        </span>
      ),
    },
    {
      title: (
        <span
          style={{
            color: '#667085',
            fontFamily: "'SF Pro Text', sans-serif",
            fontWeight: '500',
            fontSize: '12px',
            display: 'flex',
            alignItems: 'center',
          }}
        >
          Project Code
          {/* <img
            src={arrow_down}
            alt="icon"
            style={{ marginLeft: '5px', width: '16px', height: '16px' }}
          /> */}
        </span>
      ),
      dataIndex: 'project_code', // The array in bbsList
      key: 'project_code',
      width: '160px',
      ellipsis: true,
      render: (text, record) => (
        <span
          style={{
            color: '#0092DD',
            fontFamily: "'SF Pro Text', sans-serif",
            fontWeight: '500',
            fontSize: '12px',
          }}
        >
          <a
            onClick={() =>
              handleProjectClick(record?.RequestApproval?.project_code)
            } // Pass the text (project_code) here
            style={{ textDecoration: 'underline', color: '#0092DD' }} // Underline and color
          >
            {record?.RequestApproval?.project_code || 'N/A'}
          </a>
        </span>
      ),
    },
    {
      title: (
        <span
          style={{
            color: '#667085',
            fontFamily: "'SF Pro Text', sans-serif",
            fontWeight: '500',
            fontSize: '12px',
            display: 'flex',
            alignItems: 'center',
          }}
        >
          Project Name
          {/* <img
            src={arrow_down}
            alt="icon"
            style={{ marginLeft: '5px', width: '16px', height: '16px' }}
          /> */}
        </span>
      ),
      dataIndex: 'project_name',
      key: 'project_name',
      width: '160px',
      ellipsis: true,
      render: (text, record) => (
        <span
          style={{
            color: '#667085',
            fontFamily: "'SF Pro Text', sans-serif",
            fontWeight: '500',
            fontSize: '12px',
          }}
        >
          {record?.RequestApproval?.project_name || 'N/A'}
        </span>
      ),
    },
    {
      title: (
        <span
          style={{
            color: '#667085',
            fontFamily: "'SF Pro Text', sans-serif",
            fontWeight: '500',
            fontSize: '12px',
          }}
        >
          Request ID
        </span>
      ),
      dataIndex: 'request_approval_id',
      key: 'request_approval_id',
      width: '160px',
      ellipsis: true,
      render: (text) => (
        <span
          style={{
            color: '#667085',
            fontFamily: "'SF Pro Text', sans-serif",
            fontWeight: '500',
            fontSize: '12px',
          }}
        >
          {text}
        </span>
      ),
      //sorter: (a, b) => a?.required_weight?.localeCompare(b?.required_weight),
      //responsive: ['xl', 'xs', 'sm', 'xxl', 'md']
    },
    {
      title: (
        <span
          style={{
            marginLeft: '7px',
            color: '#667085',
            fontFamily: "'SF Pro Text', sans-serif",
            fontWeight: '500',
            fontSize: '12px',
            display: 'flex',
            alignItems: 'center',
          }}
        >
          BBS ID
        </span>
      ),
      dataIndex: 'BBs', // The array in bbsList
      key: 'BBS',
      width: '160px',
      ellipsis: true,
      render: (BBs, record) => {
        const bbsArray = record?.RequestApproval?.BBs || []; // Safely handle nested data
        const firstBbs = bbsArray.length > 0 ? bbsArray[0].bbs_id : 'N/A'; // Get the first bbs_id or show 'N/A'
        const additionalCount = bbsArray.length - 1; // Count of remaining BBs

        return (
          <span
            style={{
              marginLeft: '7px',
              color: '#0092DD',
              fontFamily: "'SF Pro Text', sans-serif",
              fontWeight: '500',
              fontSize: '12px',
              display: 'flex',
              gap: '5px',
            }}
          >
            {bbsArray.length > 0 ? (
              <>
                {/* Display the first BBS with a clickable link */}
                <a
                  style={{
                    textDecoration: 'underline',
                    color: '#0092DD',
                    display: 'block',
                  }}
                  onClick={() => {
                    handleFetchBBS(record.request_approval_id);

                    //console.log("Clicked on:", firstBbs);
                  }}
                >
                  {firstBbs}
                </a>

                {/* Show remaining count if there are additional BBs */}
                {additionalCount > 0 && (
                  <span
                    style={{
                      display: 'flex',
                      alignItems: 'center',
                      marginTop: '5px',
                      color: '#667085',
                      fontSize: '12px',
                    }}
                  >
                    <span
                      style={{
                        display: 'inline-flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        width: '30px', // You can adjust the size of the circle
                        height: '17px', // Same here for height
                        borderRadius: '50%', // This makes the box circular
                        backgroundColor: '#FFFFFF', // Background color for the circle
                        color: '#0092DD', // Text color inside the circle
                        fontSize: '10px', // Text size
                        fontWeight: 'bold', // Make text bold if you prefer
                        marginRight: '4px',
                        border: '1px solid #EAECF0',
                      }}
                    >
                      +{additionalCount}
                    </span>
                  </span>
                )}
              </>
            ) : (
              'N/A'
            )}
          </span>
        );
      },
    },

    {
      title: (
        <span
          style={{
            color: '#667085',
            fontFamily: "'SF Pro Text', sans-serif",
            fontWeight: '500',
            fontSize: '12px',
          }}
        >
          Project Approval Status
        </span>
      ),
      dataIndex: 'project_status',
      key: 'project_status',
      width: '160px',
      ellipsis: true,
      render: (text, record) => {
        let backgroundColor, color;

        // Set styles based on status
        if (record?.RequestApproval?.project_status === 'Approved') {
          backgroundColor = '#ECFDF3'; // Light green
          color = '#006F4B'; // Green text
        } else if (record?.RequestApproval?.project_status === 'Rejected') {
          backgroundColor = '#FFE4E4'; // Light red
          color = '#FF5252'; // Red text
        } else if (record?.RequestApproval?.project_status === 'Pending') {
          backgroundColor = '#FFF4E0'; // Light yellow
          color = '#FFB800'; // Yellow text
        } else {
          backgroundColor = '#F3F4F6'; // Default gray background
          color = '#B0B0B0'; // Default gray text
        }
        return (
          <div
            style={{
              display: 'flex',
              alignItems: 'center',
              gap: '8px', // Space between text and icon
            }}
          >
            <span
              style={{
                backgroundColor,
                paddingTop: '4px',
                paddingBottom: '4px',
                paddingLeft: '8px',
                paddingRight: '8px',
                borderRadius: '8px',
                color,
                fontWeight: '600',
                fontSize: '12px',
              }}
            >
              {record?.RequestApproval?.project_status || 'N/A'}
            </span>
            {record?.RequestApproval?.project_status === 'Rejected' && (
              <img
                src={editReject} // Replace with the actual path to your icon
                alt="Edit Reject"
                style={{
                  width: '16px',
                  height: '16px',
                  cursor: 'pointer',
                }}
                onClick={() =>
                  handleProjectApproveReject(record.request_approval_id)
                } // Add your click handler here
              />
            )}
          </div>
        );
      },
    },

    {
      title: (
        <span
          style={{
            color: '#667085',
            fontFamily: "'SF Pro Text', sans-serif",
            fontWeight: '500',
            fontSize: '12px',
          }}
        >
          User Approval Status
        </span>
      ),
      dataIndex: 'user_status', // Use the added user_status field
      key: 'user_status',
      width: '160px',
      ellipsis: true,

      render: (text, record) => {
        let backgroundColor, color;
        console.log('user_status: ', record?.user_status);
        // Set styles based on status
        if (record?.user_status === 'Approved') {
          backgroundColor = '#ECFDF3'; // Light green
          color = '#006F4B'; // Green text
        } else if (record?.user_status === 'Rejected') {
          backgroundColor = '#FFE4E4'; // Light red
          color = '#FF5252'; // Red text
        } else if (record?.user_status === 'Pending') {
          backgroundColor = '#FFF4E0'; // Light yellow
          color = '#FFB800'; // Yellow text
        } else {
          backgroundColor = '#F3F4F6'; // Default gray background
          color = '#B0B0B0'; // Default gray text
        }

        return (
          <div
            style={{
              display: 'flex',
              alignItems: 'center',
              gap: '8px', // Space between text and icon
            }}
          >
            <span
              style={{
                backgroundColor,
                paddingTop: '4px',
                paddingBottom: '4px',
                paddingLeft: '8px',
                paddingRight: '8px',
                borderRadius: '8px',
                color,
                fontWeight: '600',
                fontSize: '12px',
              }}
            >
              {record?.user_status || 'N/A'}
            </span>
            {record?.user_status === 'Rejected' && (
              <img
                src={editReject} // Replace with the actual path to your icon
                alt="Edit Reject"
                style={{
                  width: '16px',
                  height: '16px',
                  cursor: 'pointer',
                }}
                onClick={() =>
                  handleUserApproveReject(record.request_approval_id)
                } // Pass the id of the record
              />
            )}
          </div>
        );
      },
    },

    {
      render: (text, record) => {
        console.log(
          'record in page: ',
          record?.RequestApproval.manager_project_remarks,
        ); // This is fine
        console.log('record in page: ', record?.manager_user_remarks); // This is fine

        return (
          <div className="table-icons" style={{ display: 'flex', gap: '3px' }}>
            <Tooltip
              title={
                <div style={{ textAlign: 'left' }}>
                  <div
                    style={{
                      display: 'flex',
                      justifyContent: 'start',
                      alignItems: 'center',
                      marginBottom: '8px',
                      gap: '5px',
                    }}
                  >
                    <h6
                      style={{
                        margin: 0,
                        fontSize: '13px',
                        fontWeight: 'bold',
                        color: '#333',
                      }}
                    >
                      Comments
                    </h6>
                    <span
                      style={{
                        backgroundColor: '#12B76A',
                        color: '#FFFFFF',
                        padding: '2px 8px',
                        borderRadius: '12px',
                        fontSize: '8px',
                        fontWeight: 'bold',
                        textAlign: 'start',
                      }}
                    >
                      Latest
                    </span>
                  </div>
                  <p style={{ margin: 0, fontSize: '12px', color: '#101828' }}>
                    <>
                      {record?.RequestApproval?.project_status ===
                        'Approved' && (
                        <>
                          <p className="font-bold">Project remarks</p>
                          {record.RequestApproval.remarks}
                        </>
                      )}
                      {record?.user_status === 'Approved' && (
                        <>
                          <p className="font-bold">User remarks</p>
                          {record.user_remarks}
                        </>
                      )}

                      {record?.RequestApproval?.project_status ===
                      'Rejected' ? (
                        <>
                          <p className="font-bold">Project rejection remarks</p>
                          {record.RequestApproval.remarks}

                          {/* <p className="font-bold">User rejection remarks</p>
                          {record.user_remarks} */}
                        </>
                      ) : record?.RequestApproval?.project_status ===
                          'Approved' && record?.user_status === 'Rejected' ? (
                        <>
                          <p className="font-bold">User rejection remarks</p>
                          {record.user_remarks}
                        </>
                      ) : null}
                    </>
                  </p>
                </div>
              }
              overlayInnerStyle={{
                background: 'linear-gradient(180deg, #F1F1F1, #C7DCFF)', // Custom background color
                borderRadius: '8px', // Make it visually appealing
                padding: '10px', // Space for content
                width: '250px', // Adjust width for content
              }}
              placement="leftBottom"
            >
              <img
                src={check}
                alt="check"
                onClick={() => handleViewClick(record)}
                style={{ cursor: 'pointer' }}
              />
            </Tooltip>
          </div>
        );
      },
      width: '70px',
      ellipsis: true,
      responsive: ['xl', 'xs', 'sm', 'xxl', 'md'],
    },
  ];

  const ManagerColumns = [
    {
      title: (
        <span
          style={{
            marginLeft: '7px',
            color: '#667085',
            fontFamily: "'SF Pro Text', sans-serif",
            fontWeight: '500',
            fontSize: '12px',
          }}
        >
          SBG
        </span>
      ),
      dataIndex: 'sbg',
      key: 'sbg',
      width: '160px',
      ellipsis: true,
      render: (text, record) => (
        <span
          style={{
            marginLeft: '7px',
            color: '#667085',
            fontFamily: "'SF Pro Text', sans-serif",
            fontWeight: '500',
            fontSize: '12px',
          }}
        >
          {record?.RequestApproval?.sbg || 'N/A'}
        </span>
      ),
    },
    {
      title: (
        <span
          style={{
            marginLeft: '7px',
            color: '#667085',
            fontFamily: "'SF Pro Text', sans-serif",
            fontWeight: '500',
            fontSize: '12px',
          }}
        >
          SBU
        </span>
      ),
      dataIndex: 'sbu',
      key: 'sbu',
      width: '160px',
      ellipsis: true,
      render: (text, record) => (
        <span
          style={{
            color: '#667085',
            fontFamily: "'SF Pro Text', sans-serif",
            fontWeight: '500',
            fontSize: '12px',
          }}
        >
          {record?.RequestApproval?.sbu || 'N/A'}
        </span>
      ),
    },
    {
      title: (
        <span
          style={{
            color: '#667085',
            fontFamily: "'SF Pro Text', sans-serif",
            fontWeight: '500',
            fontSize: '12px',
          }}
        >
          BU
        </span>
      ),
      dataIndex: 'bu',
      key: 'bu',
      width: '160px',
      ellipsis: true,
      render: (text, record) => (
        <span
          style={{
            color: '#667085',
            fontFamily: "'SF Pro Text', sans-serif",
            fontWeight: '500',
            fontSize: '12px',
          }}
        >
          {record?.RequestApproval?.bu || 'N/A'}
        </span>
      ),
    },
    {
      title: (
        <span
          style={{
            color: '#667085',
            fontFamily: "'SF Pro Text', sans-serif",
            fontWeight: '500',
            fontSize: '12px',
          }}
        >
          Project Code
        </span>
      ),
      dataIndex: 'project_code',
      key: 'project_code',
      width: '160px',
      ellipsis: true,
      render: (text, record) => (
        <span
          style={{
            color: '#667085',
            fontFamily: "'SF Pro Text', sans-serif",
            fontWeight: '500',
            fontSize: '12px',
          }}
        >
          {record?.RequestApproval?.project_code}
        </span>
      ),
      //sorter: (a, b) => a?.required_weight?.localeCompare(b?.required_weight),
      //responsive: ['xl', 'xs', 'sm', 'xxl', 'md']
    },
    {
      title: (
        <span
          style={{
            color: '#667085',
            fontFamily: "'SF Pro Text', sans-serif",
            fontWeight: '500',
            fontSize: '12px',
            display: 'flex',
            alignItems: 'center',
          }}
        >
          Project Name
          {/* <img
            src={arrow_down}
            alt="icon"
            style={{ marginLeft: '5px', width: '16px', height: '16px' }}
          /> */}
        </span>
      ),
      dataIndex: 'project_name',
      key: 'project_name',
      width: '160px',
      ellipsis: true,
      render: (text, record) => (
        <span
          style={{
            color: '#667085',
            fontFamily: "'SF Pro Text', sans-serif",
            fontWeight: '500',
            fontSize: '12px',
          }}
        >
          {record?.RequestApproval?.project_name || 'N/A'}
        </span>
      ),
    },

    {
      title: (
        <span
          style={{
            color: '#667085',
            fontFamily: "'SF Pro Text', sans-serif",
            fontWeight: '500',
            fontSize: '12px',
            display: 'flex',
            alignItems: 'center',
          }}
        >
          Requester ID
          {/* <img
            src={arrow_down}
            alt="icon"
            style={{ marginLeft: '5px', width: '16px', height: '16px' }}
          /> */}
        </span>
      ),
      dataIndex: 'request_approval_id', // The array in bbsList
      key: 'request_approval_id',
      width: '160px',
      ellipsis: true,
      render: (text, record) => (
        <span
          style={{
            color: '#0092DD',
            fontFamily: "'SF Pro Text', sans-serif",
            fontWeight: '500',
            fontSize: '12px',
          }}
        >
          <a
            onClick={() => handleRequestClick(record.request_approval_id)} // Pass the text (project_code) here
            style={{ textDecoration: 'underline', color: '#0092DD' }} // Underline and color
          >
            {text || 'N/A'}
          </a>
        </span>
      ),
    },

    // {
    //   title: (
    //     <span
    //       style={{
    //         color: '#667085',
    //         fontFamily: "'SF Pro Text', sans-serif",
    //         fontWeight: '500',
    //         fontSize: '12px',
    //       }}
    //     >
    //       Request ID
    //     </span>
    //   ),
    //   dataIndex: 'request_approval_id',
    //   key: 'request_approval_id',
    //   width: '160px',
    //   ellipsis: true,
    //   render: (text) => (
    //     <span
    //       style={{
    //         color: '#667085',
    //         fontFamily: "'SF Pro Text', sans-serif",
    //         fontWeight: '500',
    //         fontSize: '12px',
    //       }}
    //     >
    //       {text}
    //     </span>
    //   ),
    //   //sorter: (a, b) => a?.required_weight?.localeCompare(b?.required_weight),
    //   //responsive: ['xl', 'xs', 'sm', 'xxl', 'md']
    // },
    {
      title: (
        <span
          style={{
            marginLeft: '7px',
            color: '#667085',
            fontFamily: "'SF Pro Text', sans-serif",
            fontWeight: '500',
            fontSize: '12px',
            display: 'flex',
            alignItems: 'center',
          }}
        >
          BBS ID
        </span>
      ),
      dataIndex: 'BBs', // The array in bbsList
      key: 'BBS',
      width: '160px',
      ellipsis: true,
      render: (BBs, record) => {
        const bbsArray = record?.RequestApproval?.BBs || []; // Safely handle nested data
        const firstBbs = bbsArray.length > 0 ? bbsArray[0].bbs_id : 'N/A'; // Get the first bbs_id or show 'N/A'
        const additionalCount = bbsArray.length - 1; // Count of remaining BBs

        return (
          <span
            style={{
              marginLeft: '7px',
              color: '#0092DD',
              fontFamily: "'SF Pro Text', sans-serif",
              fontWeight: '500',
              fontSize: '12px',
              display: 'flex',
              gap: '5px',
            }}
          >
            {bbsArray.length > 0 ? (
              <>
                {/* Display the first BBS with a clickable link */}
                <a
                  style={{
                    textDecoration: 'underline',
                    color: '#0092DD',
                    display: 'block',
                  }}
                  onClick={() => {
                    handleFetchBBS(record.request_approval_id);

                    //console.log("Clicked on:", firstBbs);
                  }}
                >
                  {firstBbs}
                </a>

                {/* Show remaining count if there are additional BBs */}
                {additionalCount > 0 && (
                  <span
                    style={{
                      display: 'flex',
                      alignItems: 'center',
                      marginTop: '5px',
                      color: '#667085',
                      fontSize: '12px',
                    }}
                  >
                    <span
                      style={{
                        display: 'inline-flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        width: '30px', // You can adjust the size of the circle
                        height: '17px', // Same here for height
                        borderRadius: '50%', // This makes the box circular
                        backgroundColor: '#FFFFFF', // Background color for the circle
                        color: '#0092DD', // Text color inside the circle
                        fontSize: '10px', // Text size
                        fontWeight: 'bold', // Make text bold if you prefer
                        marginRight: '4px',
                        border: '1px solid #EAECF0',
                      }}
                    >
                      +{additionalCount}
                    </span>
                  </span>
                )}
              </>
            ) : (
              'N/A'
            )}
          </span>
        );
      },
    },
    {
      title: (
        <span
          style={{
            color: '#667085',
            fontFamily: "'SF Pro Text', sans-serif",
            fontWeight: '500',
            fontSize: '12px',
            display: 'flex',
            alignItems: 'center',
          }}
        >
          User
          {/* <img
            src={arrow_down}
            alt="icon"
            style={{ marginLeft: '5px', width: '16px', height: '16px' }}
          /> */}
        </span>
      ),
      dataIndex: 'givenName',
      key: 'givenName',
      width: '160px',
      ellipsis: true,
      render: (text, record) => (
        <span
          style={{
            color: '#667085',
            fontFamily: "'SF Pro Text', sans-serif",
            fontWeight: '500',
            fontSize: '12px',
          }}
        >
          {record?.User?.givenName || 'N/A'}
        </span>
      ),
    },

    {
      title: (
        <span
          style={{
            color: '#667085',
            fontFamily: "'SF Pro Text', sans-serif",
            fontWeight: '500',
            fontSize: '12px',
          }}
        >
          Project Approval Status
        </span>
      ),
      dataIndex: 'project_status',
      key: 'project_status',
      width: '160px',
      ellipsis: true,
      render: (text, record) => {
        let backgroundColor, color;

        // Set styles based on status
        if (record?.RequestApproval?.project_status === 'Approved') {
          backgroundColor = '#ECFDF3'; // Light green
          color = '#006F4B'; // Green text
        } else if (record?.RequestApproval?.project_status === 'Rejected') {
          backgroundColor = '#FFE4E4'; // Light red
          color = '#FF5252'; // Red text
        } else if (record?.RequestApproval?.project_status === 'Pending') {
          backgroundColor = '#FFF4E0'; // Light yellow
          color = '#FFB800'; // Yellow text
        } else {
          backgroundColor = '#F3F4F6'; // Default gray background
          color = '#B0B0B0'; // Default gray text
        }

        return (
          <span
            style={{
              backgroundColor,
              paddingTop: '4px',
              paddingBottom: '4px',
              paddingLeft: '8px',
              paddingRight: '8px',
              borderRadius: '8px',
              color,
              fontWeight: '600',
              fontSize: '12px',
            }}
          >
            {record?.RequestApproval?.project_status || 'N/A' || 'N/A'}
          </span>
        );
      },
    },
    {
      title: (
        <span
          style={{
            color: '#667085',
            fontFamily: "'SF Pro Text', sans-serif",
            fontWeight: '500',
            fontSize: '12px',
          }}
        >
          User Approval Status
        </span>
      ),
      dataIndex: 'user_status', // Use the added user_status field
      key: 'user_status',
      width: '160px',
      ellipsis: true,
      render: (text) => {
        let backgroundColor, color;

        // Set styles based on status
        if (text === 'Approved') {
          backgroundColor = '#ECFDF3'; // Light green
          color = '#006F4B'; // Green text
        } else if (text === 'Rejected') {
          backgroundColor = '#FFE4E4'; // Light red
          color = '#FF5252'; // Red text
        } else if (text === 'Pending') {
          backgroundColor = '#FFF4E0'; // Light yellow
          color = '#FFB800'; // Yellow text
        } else {
          backgroundColor = '#F3F4F6'; // Default gray background
          color = '#B0B0B0'; // Default gray text
        }

        return (
          <span
            style={{
              backgroundColor,
              paddingTop: '4px',
              paddingBottom: '4px',
              paddingLeft: '8px',
              paddingRight: '8px',
              borderRadius: '8px',
              color,
              fontWeight: '600',
              fontSize: '12px',
            }}
          >
            {text || 'N/A'}
          </span>
        );
      },
    },
    {
      render: (text, record) => {
        console.log('record in manager: ', record); // Move console.log outside return

        return (
          <div className="table-icons" style={{ display: 'flex', gap: '3px' }}>
            <Tooltip
              title={
                <div style={{ textAlign: 'left' }}>
                  <div
                    style={{
                      display: 'flex',
                      justifyContent: 'start',
                      alignItems: 'center',
                      marginBottom: '8px',
                      gap: '5px',
                    }}
                  >
                    <h6
                      style={{
                        margin: 0,
                        fontSize: '13px',
                        fontWeight: 'bold',
                        color: '#333',
                      }}
                    >
                      Comments
                    </h6>
                    <span
                      style={{
                        backgroundColor: '#12B76A',
                        color: '#FFFFFF',
                        padding: '2px 8px',
                        borderRadius: '12px',
                        fontSize: '8px',
                        fontWeight: 'bold',
                        textAlign: 'start',
                      }}
                    >
                      Latest
                    </span>
                  </div>

                  <p style={{ margin: 0, fontSize: '12px', color: '#101828' }}>
                    <>
                      {record?.RequestApproval?.project_status === 'Approved' &&
                      record?.user_status === 'Approved'
                        ? record?.manager_user_remarks &&
                          record.manager_user_remarks.trim() !== 'N/A'
                          ? record.manager_user_remarks
                          : record?.RequestApproval?.manager_project_remarks
                        : record?.RequestApproval?.project_status === 'Approved'
                          ? record?.manager_user_remarks &&
                            record.manager_user_remarks.trim() !== 'N/A'
                            ? record.manager_user_remarks
                            : record?.RequestApproval?.manager_project_remarks
                          : record?.RequestApproval?.manager_project_remarks}
                    </>
                  </p>
                </div>
              }
              overlayInnerStyle={{
                background: 'linear-gradient(180deg, #F1F1F1, #C7DCFF)',
                borderRadius: '8px',
                padding: '10px',
                width: '250px',
              }}
              placement="leftBottom"
            >
              <img
                src={check}
                alt="check"
                onClick={() => handleViewClick(record)}
                style={{ cursor: 'pointer' }}
              />
            </Tooltip>
          </div>
        );
      },
      width: '70px',
      ellipsis: true,
      responsive: ['xl', 'xs', 'sm', 'xxl', 'md'],
    },
  ];

  const dummyData = [
    {
      key: '1',
      project_code: 'PC001',
      project_name: 'Project One',
      status: 'Active',
    },
    {
      key: '2',
      project_code: 'PC002',
      project_name: 'Project Two',
      status: 'Inactive',
    },
    {
      key: '3',
      project_code: 'PC003',
      project_name: 'Project Three',
      status: 'Active',
    },
    {
      key: '4',
      project_code: 'PC004',
      project_name: 'Project Four',
      status: 'Completed',
    },
  ];

  // Columns for the table
  const columns1 = [
    {
      title: (
        <span
          style={{
            color: '#667085',
            fontFamily: "'SF Pro Text', sans-serif",
            fontWeight: '500',
            fontSize: '11px',
          }}
        >
          BBS
        </span>
      ),
      dataIndex: 'bbs_id',
      key: 'bbs_id',
      width: '160px',
      ellipsis: true,
      render: (text) => (
        <span
          style={{
            color: '#667085',
            fontFamily: "'SF Pro Text', sans-serif",
            fontWeight: '500',
            fontSize: '11px',
          }}
        >
          {text}
        </span>
      ),
      //sorter: (a, b) => a?.required_weight?.localeCompare(b?.required_weight),
      //responsive: ['xl', 'xs', 'sm', 'xxl', 'md']
    },
    {
      title: (
        <span
          style={{
            marginLeft: '7px',
            color: '#667085',
            fontFamily: "'SF Pro Text', sans-serif",
            fontWeight: '500',
            fontSize: '11px',
            display: 'flex',
            alignItems: 'center',
          }}
        >
          Project Code
          <img
            src={arrow_down}
            alt="icon"
            style={{ marginLeft: '5px', width: '16px', height: '16px' }}
          />
        </span>
      ),
      dataIndex: 'Project', // The array in bbsList
      key: 'project_code',
      width: '160px',
      ellipsis: true,
      render: (project) => (
        <span
          style={{
            marginLeft: '7px',
            color: '#0092DD',
            fontFamily: "'SF Pro Text', sans-serif",
            fontWeight: '500',
            fontSize: '11px',
          }}
        >
          <a
            //href={`/projects/${project?.project_code}`}
            onClick={handleProjectClick}
            style={{ textDecoration: 'underline', color: '#0092DD' }} // Underline and color
          >
            {project?.project_code || 'N/A'}
          </a>
        </span>
      ),
    },
    {
      title: (
        <span
          style={{
            color: '#667085',
            fontFamily: "'SF Pro Text', sans-serif",
            fontWeight: '500',
            fontSize: '11px',
            display: 'flex',
            alignItems: 'center',
          }}
        >
          User Name
        </span>
      ),
      dataIndex: 'Project',
      key: 'project_name',
      width: '160px',
      ellipsis: true,
      render: (project) => (
        <span
          style={{
            color: '#667085',
            fontFamily: "'SF Pro Text', sans-serif",
            fontWeight: '500',
            fontSize: '11px',
          }}
        >
          {project?.project_name || 'N/A'}
        </span>
      ),
    },
    {
      title: (
        <span
          style={{
            color: '#667085',
            fontFamily: "'SF Pro Text', sans-serif",
            fontWeight: '500',
            fontSize: '11px',
          }}
        >
          Download BBS Optimized Files
        </span>
      ),
      dataIndex: 'sbg_id',
      key: 'sbg_id',
      width: '160px',
      ellipsis: true,
      render: (text) => (
        <span
          style={{
            color: '#667085',
            fontFamily: "'SF Pro Text', sans-serif",
            fontWeight: '500',
            fontSize: '11px',
          }}
        >
          <img src={modal_download}></img>
        </span>
      ),
    },
    {
      title: (
        <span
          style={{
            color: '#667085',
            fontFamily: "'SF Pro Text', sans-serif",
            fontWeight: '500',
            fontSize: '11px',
          }}
        >
          Download BBS Summary Files
        </span>
      ),
      dataIndex: 'sbu_id',
      key: 'sbu_id',
      width: '160px',
      ellipsis: true,
      render: (text) => (
        <span
          style={{
            color: '#667085',
            fontFamily: "'SF Pro Text', sans-serif",
            fontWeight: '500',
            fontSize: '11px',
          }}
        >
          <img src={modal_download}></img>
        </span>
      ),
    },
  ];

  const handleClickBBS = () => {
    setIsExistingBBS(false);
    dispatch(getApproverDashboard());
  };

  return (
    <div className="main-div">
      {!isExistingBBS ? (
        <>
          <div className="flex items-center justify-between">
            <div className="flex items-center gap-2 barchart-text">
              <img src={barChart} alt="bar chart" />
              {user_details?.user?.Role?.role === 'REQUESTER' && (
                <p className="p-1 text-sm font-semibold text-gray-700 bg-white rounded-lg">
                  Dashboard
                </p>
              )}

              {user_details?.user?.Role?.role === 'MANAGER' && (
                <p className="p-1 text-sm font-semibold text-gray-700 bg-white rounded-lg">
                  Approval Dashboard
                </p>
              )}
            </div>
            {user_details?.user?.Role?.role === 'REQUESTER' && (
            <button
              onClick={showDrawer}
              className="cursor-pointer text-xs flex items-center gap-2.5 h-8 px-2.5 font-['SF-Pro-Text-Regular, sans-serif'] font-medium text-tertiary-text bg-secondary-bg mr-8 mt-4"
            >
              {selectedFilters.length
                ? `${selectedFilters.slice(0, 2).join(', ')}...`
                : LAST_MONTH}
              <img src={filterIcon} alt="Filter Icon" />
            </button>
            )}
            <FilterDrawerMonthlyWithYear
              onClose={onClose}
              open={openDr}
              onSubmit={handleFilter}
              lastMonth={selectedFilters.length ? selectedFilters : LAST_MONTH}
              financialYears={FINANCIAL_YEARS}
            />
              
          </div>
          <div className="flex justify-between gap-5 p-5 card-container">
            <div className="big-card flex-1 w-[300px] p-5 bg-white rounded-lg">
              <p className="m-0 text-sm font-medium leading-7 text-gray-500 p1">
                Total Projects
              </p>
              {/* <p className="font-['SF-Pro-Text-Regular, sans-serif'] text-[#667085] text-[11px] font-normal leading-[14px] m-0">
                FY24-25 (1-Apr-24 to 31-Mar-25)
              </p> */}
              <p className="my-1 text-3xl font-bold leading-6 text-gray-900 p2">
                {user_details?.user?.Role?.role === 'MANAGER'
                  ? managerProjectCountDashboard?.project_count || 'N/A'
                  : projectCountDashboard?.project_count || 'N/A'}
              </p>
              {/* <div className="flex items-center gap-1 image-arrow">
                <img src={arrow} alt="arrow" className="w-5 h-5" />
                <p className="text-gray-500 p3">
                  <span className="text-green-700">40%</span> vs last month
                </p>
              </div> */}
            </div>
            <div className="big-card flex-1 w-[300px] p-5 bg-white rounded-lg">
              <p className="m-0 text-sm font-medium leading-7 text-gray-500 p1">
                No. of BBS Optimized
              </p>
              {/* <p className="font-['SF-Pro-Text-Regular, sans-serif'] text-[#667085] text-[11px] font-normal leading-[14px] m-0">
                FY24-25 (1-Apr-24 to 31-Mar-25)
              </p> */}
              <p className="my-1 text-3xl font-bold leading-6 text-gray-900 p2">
                {user_details?.user?.Role?.role === 'MANAGER'
                  ? managerOptimizationCountDashboard?.optimization_count ||
                    'N/A'
                  : optimizationCountDashboard?.optimization_count || 'N/A'}
              </p>
              {/* <div className="flex items-center gap-1 image-arrow">
                <img src={arrow} alt="arrow" className="w-5 h-5" />
                <p className="text-gray-500 p3">
                <span className="text-green-700">80%</span> vs last month
                </p>
                
              </div> */}
            </div>
            <div className="big-card flex-1 w-[300px] p-5 bg-white rounded-lg">
              <p className="m-0 text-sm font-medium leading-7 text-gray-500 p1">
                Quantity Optimized (in MT)
              </p>
              {/* <p className="font-['SF-Pro-Text-Regular, sans-serif'] text-[#667085] text-[11px] font-normal leading-[14px] m-0">
                FY24-25 (1-Apr-24 to 31-Mar-25)
              </p> */}
              <p className="my-1 text-3xl font-bold leading-6 text-gray-900 p2">
                {user_details?.user?.Role?.role === 'MANAGER'
                  ? managerProjectCountDashboard?.tonnage_count
                    ? managerProjectCountDashboard.tonnage_count.toFixed(2)
                    : 'N/A'
                  : projectCountDashboard?.tonnage_count
                    ? projectCountDashboard.tonnage_count.toFixed(2)
                    : 'N/A'}
              </p>
              {/* <div className="flex items-center gap-1 image-arrow">
                <img src={arrow} alt="arrow" className="w-5 h-5" />
                <p className="text-gray-500 p3">
                  <span className="text-green-700">10%</span> vs last month
                </p>
              </div> */}
            </div>
          </div>

          <div className="table-main1 ">
            <div className="table-heading">
              <p className="heading ">Project List</p>
              {/* <p className="para ">
                Keep a detailed record of projects and their key information
              </p> */}
            </div>

            <div className="flex justify-end gap-2 search-bar-container ">
              <div className="relative search_icon">
                <img
                  src={search_icon}
                  alt="search"
                  className="absolute left-2"
                />
                {user_details?.user?.Role?.role === 'MANAGER' ? (
                  // Input field for MANAGER
                  <input
                    type="text"
                    placeholder="Search by project code"
                    value={managerSearch}
                    onChange={(e) => setManagerSearch(e.target.value)}
                    className="py-2 pl-8 border border-gray-300 rounded-lg search-input manager"
                  />
                ) : (
                  // Input field for REQUESTER
                  <input
                    type="text"
                    placeholder="Search by project code"
                    value={requesterSearch}
                    onChange={(e) => setRequesterSearch(e.target.value)}
                    className="py-2 pl-8 border border-gray-300 rounded-lg search-input requester"
                  />
                )}
                {/* <input
                  type="text"
                  placeholder="Search by project code"
                  value={search}
                  onChange={(e) => setSearch(e.target.value)}
                  className={`search-input pl-8 py-2 rounded-lg border border-gray-300 ${
                    user_details?.user?.Role?.role === 'MANAGER'
                      ? 'manager'
                      : 'requester'
                  }`}
                /> */}
              </div>
              {user_details?.user?.Role?.role === 'REQUESTER' && (
                <div className="relative plus_icon">
                  <img src={plus} alt="plus" className="" />
                  <button
                    onClick={() => handleNewBBS(Id)}
                    className="bbs-button font-['SF-Pro-Text-Regular, sans-serif'] text-[14px] "
                  >
                    Create BBS
                  </button>
                </div>
              )}
            </div>
          </div>

          <div className="p-[20px]">
            <Divider style={{ marginTop: '-15px' }} />
            {user_details?.user?.Role?.role === 'REQUESTER' && (
              <DashboardTable
                dataSource={dataSource}
                columns={columns}
                search={requesterSearch}
                monthFilter={memoizedMonthFilter}

                //pagination={approverDashboard?.paginationInfo?.itemsPerPage  || 0}
              />
            )}

            {user_details?.user?.Role?.role === 'MANAGER' && (
              <DashboardTableManager
                dataSource={managerDatasource} // Flattening the array
                columns={ManagerColumns}
                search={managerSearch}
                //loading={loading}
                total={managerDashboard?.paginationInfo?.totalItems || 0}
              />
            )}
          </div>

          <Modal
            title={
              <div
                style={{
                  fontFamily: "'SF Pro Text', sans-serif",
                  fontSize: '14px',
                  marginBottom: '20px',
                  color: '#344054',
                }}
              >
                Project Code: PRO-00012
              </div>
            }
            centered
            open={open}
            onCancel={handleModalClose} // Close the modal on Cancel click
            width={942}
            height={347}
            footer={null}
          >
            <Table
              dataSource={dummyData} // Pass the dummy data to the table
              columns={columns1} // Pass the columns for the table
              bordered
              pagination={false}
              scroll={{ x: 'max-content' }}
              className="responsive-table" /* {{ total: dummyData.length }}*/
            />
          </Modal>
        </>
      ) : (
        <>
          <ViewBBS
            isExistingBBS={isExistingBBS}
            setIsExistingBBS={setIsExistingBBS}
            currpage={currpage}
            setCurrPage={setCurrPage}
          />
        </>
      )}
    </div>
  );
};

export default DashboardPage;
